<template>
    <button type="submit" @click="$emit('click')" :disabled="isLoading || isDisabled"
    :class="!disableButtonAnimation ? 'button-animation' : ''">
      <span v-if="!isLoading" :class="isBold ? 'bold-text' : ''">{{ label }}</span>
      <span v-else class="loader"></span>
    </button>
  </template>
  
  <script>
  export default {
    name: 'SubmitButton',
    props: {
      disableButtonAnimation: {
        type: Boolean,
        default: false
      },
      label: {
        type: String,
        default: 'Submit'
      },
      isLoading: {
        type: Boolean,
        default: false
      },
      isDisabled: {
        type: Boolean,
        default: false
      },
      isBold: {
        type: Boolean,
        default: false
      }
    },
    computed: {
			isLandingPage: function() {
				return this.$route.name ==='homePage'
			},
    }
  };
  </script>
  
  <style scoped>
  button {
    width: 100%;
    background-color: #FFA726;
    color: #020076;
    border: none;
    border-radius: 6px;
    font-weight: bold;
    cursor: pointer;
    transition: background-color 0.3s;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px; /* Ensures consistency when switching between text and loader */
    position: relative;
    font-family: "Nunito-Regular";
    font-size: 16px;
    line-height: 1;
  }
  .bold-text {
    font-family: "Nunito-ExtraBold" !important;
  }
  .button-animation {
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 1);
		transform: scale(1);
		animation: pulse_button 2s infinite;
  }
  button:focus.button-animation {
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 1);
		transform: scale(1);
		animation: pulse_button 2s infinite;
  }
  button:hover.button-animation {
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 1);
		transform: scale(1);
		animation: pulse_button 2s infinite;
  }
  @keyframes pulse_button {
			0% {
				transform: scale(0.95);
				box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.7);

      }

			70% {
				transform: scale(1);
				box-shadow: 0 0 0 10px rgba(0, 0, 0, 0);

      }

			100% {
				transform: scale(0.95);
				box-shadow: 0 0 0 0 rgba(0, 0, 0, 0);

      }

    }
  
  button:disabled {
    cursor: not-allowed;
    opacity: 0.7;
  }
  
  /* Loader Styling */
  .loader {
    width: 20px;
    height: 20px;
    border: 2px solid #020076;
    border-top: 2px solid transparent;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  </style>
  